import type { TourStep } from '../types';

export const productCreateSteps: TourStep[] = [
  {
    target: '[data-tour="product-modal"]',
    title: 'Создание товара',
    content: 'Это форма создания нового товара в PIM-системе. Заполните обязательные поля (отмечены *) и нажмите "Создать".',
    placement: 'left',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-design-id"]',
    title: 'Design ID',
    content: 'Номер дизайна из раздела "Дизайны". Связывает товар с конкретным макетом. Найдите нужный дизайн и скопируйте его номер.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-article"]',
    title: 'Артикул',
    content: 'Уникальный код товара. Формат: КАТЕГОРИЯ-НОМЕР (например: CUP-1234). Артикул должен быть уникальным в каталоге.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-title"]',
    title: 'Название товара',
    content: 'Полное название товара для маркетплейсов. Указывайте ключевые характеристики: тип, материал, дизайн, бренд.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-category"]',
    title: 'Категория',
    content: 'Выберите категорию товара. Категория определяет состав, размеры, сертификаты и другие характеристики товара.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-barcode"]',
    title: 'Баркод (штрихкод)',
    content: 'EAN-13 код товара для идентификации. Если не указан, будет сгенерирован автоматически при выгрузке на маркетплейс.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-shelf-life"]',
    title: 'Срок годности',
    content: 'Срок годности товара. Указывается для товаров с ограниченным сроком хранения (например, продукты питания).',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-country"]',
    title: 'Страна происхождения',
    content: 'Страна производства товара. Обязательное поле для маркетплейсов. Указывайте полное название страны.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-price"]',
    title: 'Цена',
    content: 'Базовая цена товара. Цена может отличаться на разных маркетплейсах в зависимости от настроек наценки.',
    placement: 'bottom',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-composition"]',
    title: 'Состав',
    content: 'Состав материала товара. Например: "Керамика 100%", "Хлопок 95%, Эластан 5%". Важно для текстильных товаров.',
    placement: 'top',
    disableBeacon: true,
  },
  {
    target: '[data-tour="product-form-submit"]',
    title: 'Создание товара',
    content: 'После заполнения всех полей нажмите "Создать товар". Товар появится в каталоге и будет готов к выгрузке.',
    placement: 'top',
    disableBeacon: true,
  },
];
